import React from "react"
import PropTypes from "prop-types"
import {
  rendezVousTitle,
  rendezVousSubContainerWithStep,
  rendezVousPart3Add,
  rendezVousPart3Delete,
  rendezVousPart3PersonneContainer,
  rendezVousPart3NbPersonne,
  vocalizedUpdate,
} from "../Part3/rendez-vous-part-3.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
  RendezVousPart3Delete,
  RendezVousPart3Add,
} from "../rendez-vous-styled.js"
import { StepIndicator } from "../StepIndicator/step-indicator"

export const RendezVousPart3 = ({
  typesRendezVousData,
  typeChoisi,
  setNombrePersonne,
  nombrePersonne,
  step,
  stepRefs,
}) => {
  const nbMaxPersonne = typesRendezVousData[typeChoisi].nb_max_personne[0].value

  return (
    <RendezVousSubContainer className={rendezVousSubContainerWithStep}>
      <StepIndicator step={step} refs={stepRefs} />
      <RendezVousTitle className={rendezVousTitle}>
        Nombre de personnes concernées par la demande
      </RendezVousTitle>
      <p>
        Veuillez indiquer le nombre de personnes concernées par la demande
        (maximum {nbMaxPersonne} {nbMaxPersonne > 1 ? "personnes" : "personne"},
        au delà, contactez votre mairie.)
      </p>
      <div className={rendezVousPart3PersonneContainer}>
        <p>TOTAL : </p>
        <RendezVousPart3Delete
          className={rendezVousPart3Delete}
          onClick={() => setNombrePersonne(Math.max(1, nombrePersonne - 1))}
        >
          -
        </RendezVousPart3Delete>
        <RendezVousPart3Add
          className={rendezVousPart3Add}
          onClick={() =>
            setNombrePersonne(
              Math.min(
                typesRendezVousData[typeChoisi].nb_max_personne[0].value,
                nombrePersonne + 1
              )
            )
          }
        >
          +
        </RendezVousPart3Add>
        <p className={rendezVousPart3NbPersonne}>{nombrePersonne}</p>
        <p className={vocalizedUpdate} role="status" aria-live="polite">
          {nombrePersonne + " personnes"}
        </p>
      </div>
    </RendezVousSubContainer>
  )
}

RendezVousPart3.propTypes = {
  typesRendezVousData: PropTypes.object,
  typeChoisi: PropTypes.number,
  setNombrePersonne: PropTypes.func,
  nombrePersonne: PropTypes.number,
  step: PropTypes.number,
  stepRefs: PropTypes.arrayOf(PropTypes.shape({ current: PropTypes.any })),
}
